import React, { useContext, useEffect } from 'react';
import { IceCreamImage, VodapayLogoV2 } from 'src/assets/images';
import { HelpButton, NavigationBarFooter } from '../../components';
import { contacts, publicSiteUrl } from 'src/common';
import './declined-application.scss';
import { ApplicationContext } from 'src/features/onboarding/context';

export const DeclinedApplication = () => {
  const { onboardingTealiumService } = useContext(ApplicationContext);

  useEffect(() => {
    onboardingTealiumService.onOnboardingDeclinedStart();
  }, []);

  return (
    <article className="declined-application">
      <img src={VodapayLogoV2} alt="Vodapay Logo" id="vodapay" />

      <h1>Sorry, your application has been declined!</h1>
      <p>
        For queries contact us on{' '}
        <a
          href={contacts.numberUrl}
          className="underline"
          onClick={() => onboardingTealiumService.onOnboardingDeclinedAction('call support')}
        >
          {contacts.number}
        </a>{' '}
        or{' '}
        <a
          href={contacts.emailUrl}
          className="underline red"
          onClick={() => onboardingTealiumService.onOnboardingDeclinedAction('email support')}
        >
          {contacts.email}
        </a>{' '}
      </p>

      <img src={IceCreamImage} alt="Ice Cream" id="ice-cream" />

      <NavigationBarFooter
        showNext
        softDisable={false}
        nextEnabled
        nextButtonLabel="Exit"
        onNext={() => {
          onboardingTealiumService.onOnboardingDeclinedEnd();
          window.location.href = publicSiteUrl;
        }}
      />
      <HelpButton />
    </article>
  );
};
